import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
}, km({
  ENTERPRISE_INIT_CARDS: null,
  ENTERPRISE_GET_CARD_NOMORE_STATUS: null,
  ENTERPRISE_GET_RECOMMEND_SUCCESS: null,
  ENTERPRISE_GET_RECOMMEND_ERROR: null,
  ENTERPRISE_GET_CARD_SUCCESS: null,
  ENTERPRISE_GET_CARD_ERROR: null,

  ENTERPRISE_BILLBOARDS_GET_LIST_START: null,
  ENTERPRISE_BILLBOARDS_GET_LIST_SUCCESS: null,
  ENTERPRISE_BILLBOARDS_GET_LIST_ERROR: null,

  ENTERPRISE_SHOPS_GET_LIST_START: null,
  ENTERPRISE_SHOPS_GET_LIST_SUCCESS: null,
  ENTERPRISE_SHOPS_GET_LIST_ERROR: null,

    /*yeoman-template-point-1*/
}))
